import { StrapiVideo } from '@/types/strapi/Strapi.type'
import { ArticlePublishersName, ResourceType } from '@/types/ressources/Ressource.type'
import axios from 'axios'
import { GetArticlesResponse } from '@/types/response/GetArticlesResponse'
import { ArticleType } from '@/types/response/GetArticleResponse'

interface ResourceOptions {
    recommended?: boolean
    page?: number
    limit?: number
    publisher?: ArticlePublishersName | ArticlePublishersName[]
    categories?: string
    type?: ResourceType
}

const http = axios.create({
    baseURL: process.env.VUE_APP_CMS_BASE_URL,
})

const DEFAULT_PAGINATION_LIMIT = 5

const formatOptions = (options: ResourceOptions = {}) => {
    const params: {
        [key: string]: unknown
    } = { ...options }
    const limit = options?.limit || DEFAULT_PAGINATION_LIMIT

    // Handle option page for pagination
    if (typeof options.page !== 'undefined') {
        params._start = (options.page - 1) * limit
        params._limit = limit
        delete params.page
    }

    // Handle option limit for max items for this call
    if (typeof options.limit !== 'undefined') {
        params._limit = limit
        delete params.limit
    }

    // Handle filter publish
    if (typeof options.publisher === 'undefined') {
        params['publishers.name_in'] = [
            ArticlePublishersName.NETWORK,
            ArticlePublishersName.PUBLIC,
            ArticlePublishersName.LES_TALENTS,
            ArticlePublishersName.IC,
        ]
    } else {
        params['publishers.name_in'] = typeof options.publisher === 'string' ? [options.publisher] : options.publisher
        delete params.publisher
    }
    if (options.categories !== null) {
        params['category.name_contains'] = options.categories
        delete params.categories
    }

    params._sort = 'published_date:DESC'

    delete params.type

    return params
}

export default class APIStrapi {
    static async getVideoList(options?: ResourceOptions): Promise<StrapiVideo[]> {
        const response = await http.get('/videos', {
            params: formatOptions(options),
        })
        return response?.data
    }

    static async getArticles(): Promise<GetArticlesResponse> {
        const response = await http.get(`/articles?publishers.id_in[]=1`)

        return response.data
    }

    static async getArticle(articleName: string): Promise<ArticleType> {
        const response = await http.get(`/articles/${articleName}`)

        return response.data
    }
}
